module.exports = __webpack_public_path__ + "media/images/foot_bg-105117ce0f1a79bfbdcb2b9354951936.gif";